//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/SelectNXObjectList.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BackliteWindshieldFace",0,"ScCollector",0],[1,"BackliteWindshieldFacetBodies",0,"SelectNXObjectList",0],[1,"BezelCurve",0,"Section",0],[1,"Calotte",0,"Expression",0],[1,"CurvatureChange",0,"Expression",0],[0,"MirrorClass",1,0],[1,"MirrorFace",0,"ScCollector",0],[1,"MirrorFacetBodies",0,"SelectNXObjectList",0],[0,"MirrorLocation",1,0],[1,"MirrorRadius",0,"Expression",0],[0,"MirrorType",1,0],[0,"PivotPoint",1,"Point",0],[0,"PrimePoint",1,"Point",0]],[[["nUserRemarks"],"GetUserRemarks",{R_:{userRemarks:""}},0,0],[["userRemarks"],"SetUserRemarks",{},1,0]],[]];
SPLM.Features.VDVMirrorBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VDVMirrorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VDVMirrorBuilder.MirrorLocations = Object.freeze({
    "Inside" : "Inside", "DriverSide" : "DriverSide", "PassengerSide" : "PassengerSide", "Rear" : "Rear"});

SPLM.Features.VDVMirrorBuilder.MirrorClasses = Object.freeze({
    "ClassI" : "ClassI", "ClassII" : "ClassII", "ClassIII" : "ClassIII", "ClassIV" : "ClassIV", "ClassV" : "ClassV", "ClassVI" : "ClassVI", "ClassVII" : "ClassVII", "UserDefined" : "UserDefined"});

SPLM.Features.VDVMirrorBuilder.MirrorTypes = Object.freeze({
    "Planar" : "Planar", "Spherical" : "Spherical", "Aspherical" : "Aspherical"});

export default SPLM;